<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {ItemStateNotice} from "@/modules/redactor/models/item/ItemStateNotice";

export default {
  name: "r-item-state-notice",
  props: {
    model: VueTypes.instanceOf(ItemStateNotice),
    label: VueTypes.string.def("Notice:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ItemStateNotice.getValues();
    }
  }
}

</script>
